/* eslint-disable */ import { DomainBuilder, DomainComponentOpticBuilder, InvariantBuilder, RecipeFactoryBuilder, createConstantExpressionFactory, createCustomExpressionFactory, createCustomInvariantFactory, createRelationFactory } from '@salsita-ai/platform-project-sdk/domain';
import { BackendData, FrontendData, PublishedData, SessionData } from './application-types.js';
import { $entityReflections, constants } from './enhanced-model.js';
import { AnyDomainEntity, RootEntity, aliases, entities, modelVersion } from './model/index.js';
const implementRelation = createRelationFactory(aliases);
export const relationExpressions = {
    Deck: {
        $items: implementRelation({
            kind: 'allOfType',
            target: 'DeckItem',
            cardinality: '0-N'
        })
    },
    DeckItem: {
        $deck: implementRelation({
            kind: 'allOfType',
            target: 'Deck',
            cardinality: '1-1'
        }),
        $projectedEntities: implementRelation({
            kind: 'indirect',
            field: 'deckItemId',
            target: 'ProjectedEntity',
            cardinality: '0-N'
        })
    },
    ProjectedEntity: {
        $deckItem: implementRelation({
            kind: 'direct',
            field: 'deckItemId',
            target: 'DeckItem',
            cardinality: '1-1'
        })
    }
};
export const constantExpressions = createConstantExpressionFactory({} // insert expression metas here, once ready
)(constants);
export const createRecipe = RecipeFactoryBuilder.forAliases(aliases).forEntities(AnyDomainEntity.reflections).withDefaults({}).build();
const staticViolations = {
    Deck: {
        noIntermediateWithRoundPosts: {
            type: 'noIntermediateWithRoundPosts',
            severity: 'fatal',
            message: /*i18n*/ {
                id: "LrqMmn",
                message: "Intermediate posts are not available for round stainless posts."
            }
        },
        stainlessHandrail: {
            type: 'stainlessHandrail',
            severity: 'fatal',
            message: /*i18n*/ {
                id: "yWb+GK",
                message: "The round and square stainless handrails are only available for the stainless posts, for own metal posts or aluminium posts flat timber is the only available option."
            }
        },
        noSeparateBranches: {
            type: 'noSeparateBranches',
            severity: 'fatal',
            message: /*i18n*/ {
                id: "Khjblk",
                message: "All sketching parts need to be connected!"
            }
        },
        noClosedShapes: {
            type: 'noClosedShapes',
            severity: 'fatal',
            message: /*i18n*/ {
                id: "NyDklC",
                message: "All sketching parts need to be open shapes!"
            }
        },
        connectedStairs: {
            type: 'connectedStairs',
            severity: 'fatal',
            message: /*i18n*/ {
                id: "iF3LWq",
                message: "Stairs can not be connected to other stairs!"
            }
        },
        only45Degrees: {
            type: 'only45Degrees',
            severity: 'fatal',
            message: /*i18n*/ {
                id: "NgpVNW",
                message: "Balustrades can be connected only at 45 degree increments!"
            }
        },
        no45DegToggleLock: {
            type: 'no45DegToggleLock',
            severity: 'fatal',
            message: /*i18n*/ {
                id: "UTpYm2",
                message: "The toggle lock is not available for square posts connected with 45 angles."
            }
        }
    }
};
export const implementCustomInvariants = createCustomInvariantFactory()(staticViolations);
export const invariantBuilder = new InvariantBuilder(aliases);
export const attachComponent = DomainComponentOpticBuilder.from(aliases);
export const implementCustomExpressions = createCustomExpressionFactory({} // TODO pass in meta-data once we have them
);
export const dataExpressions = implementCustomExpressions({});
export const domainBuilder = DomainBuilder.from(entities, aliases, $entityReflections, RootEntity.types, modelVersion, PublishedData, SessionData, FrontendData, BackendData, false).withExpressions(constantExpressions).withExpressions(relationExpressions).withExpressions(dataExpressions);

//# sourceMappingURL=implementation.js.map